<ul
  class="transition-opacity"
  [class.opacity-60]="muted()"
  [attr.aria-busy]="muted() || null">
  @for (row of rows(); track $index) {
    <li data-testid="change-row" class="border-weak border-b last:border-b-0">
      <button
        type="button"
        class="hover:bg-interactive -mx-1.5 flex w-[calc(100%+0.75rem)] cursor-pointer items-start gap-2 rounded-sm px-1.5 py-1.5 text-left transition-colors focus-visible:shadow-[var(--shadow-focus)]"
        (click)="openCard(row, $event)">
        <app-badge class="mt-px shrink-0" [status]="TAG_STATUS[row.kind]">
          {{ 'features.plan.panel.changes.' + row.kind | translate }}
        </app-badge>
        <span
          class="min-w-0 text-xs leading-snug break-words"
          [class]="
            row.kind === 'gone' ? 'text-text-tertiary line-through' : 'text-text-secondary'
          ">
          <app-finding-message
            class="inline"
            [muted]="row.kind === 'gone'"
            [parts]="row.parts"
            [body]="row.body"
            [sameDay]="sameDay()"
            [typeLabels]="typeLabels()" />
          @if (row.was !== null) {
            <span class="text-text-secondary">
              ({{ 'features.plan.panel.changes.was' | translate: { value: row.was } }})
            </span>
          }
        </span>
      </button>
    </li>
  } @empty {
    <li class="text-text-tertiary text-xs">
      {{ 'features.plan.panel.changes.nothing' | translate }}
    </li>
  }
</ul>
